// Verlangt vor dem administrativen 2FA-Reset eine nachvollziehbare Begründung.
import React, { useEffect, useState } from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	TextField
} from "@material-ui/core";

const MfaResetDialog = ({ open, user, processing, onCancel, onConfirm }) => {
	const [reason, setReason] = useState("");
	useEffect(() => {
		if (open) setReason("");
	}, [open, user]);

	return <Dialog open={open} onClose={processing ? undefined : onCancel} disableEscapeKeyDown={processing}>
		<DialogTitle>Authenticator zurücksetzen?</DialogTitle>
		<DialogContent>
			<DialogContentText>
				Alle bestehenden Sitzungen von {user ? user.name : "diesem Benutzer"} werden beendet.
				 Beim nächsten Login muss ein neuer Authenticator eingerichtet werden.
			</DialogContentText>
			<TextField
				id="mfa-reset-reason"
				label="Begründung"
				value={reason}
				onChange={(event) => setReason(event.target.value.slice(0, 255))}
				fullWidth
				required
				multiline
				minRows={3}
				variant="outlined"
				inputProps={{ maxLength: 255 }}
			/>
		</DialogContent>
		<DialogActions>
			<Button onClick={onCancel} disabled={processing}>Abbrechen</Button>
			<Button
				onClick={() => onConfirm(reason.trim())}
				disabled={processing || !reason.trim()}
				color="secondary"
				variant="contained"
			>
				2FA zurücksetzen
			</Button>
		</DialogActions>
	</Dialog>;
};

export default MfaResetDialog;
